import VuexPersistence from 'vuex-persist';

export default ({ store }) => {
  new VuexPersistence({
    reducer: ({ user, requisitionCandidateSortBy }) => ({ user, requisitionCandidateSortBy }),
  }).plugin(store);
};
